export enum RewardCardType {
  REFERRER = 'referrer',
  WELCOME = 'welcome',
}
